// Legal documents content - centralized for all app screens
// These serve as fallback when API is unavailable

export const TERMS_CONTENT = {
  // Main platform terms shown during signup (Regulamin korzystania z platformy)
  MAIN_TERMS: `REGULAMIN KORZYSTANIA Z PLATFORMY SPOTTO

1. Postanowienia ogólne
1.1. Niniejszy regulamin określa zasady korzystania z serwisu internetowego SPOTTO.pl, działającego pod adresem www.spotto.pl (dalej „Serwis" lub „Platforma").

1.2. Właścicielem i administratorem Serwisu jest SOLIDLABS PSA, ul. Mogilska 43, 31-545 Kraków, Polska, NIP: 6751768986, zwany dalej „Administratorem" lub „Usługodawcą".

1.3. Serwis umożliwia użytkownikom dokonywanie rezerwacji obiektów sportowych (m.in. strzelnic, kortów tenisowych, boisk) oraz zakupu produktów u usług dostępnych na Platformie.

1.4. Niniejszy Regulamin określa zasady świadczenia usług drogą elektroniczną, prawa i obowiązki Użytkowników oraz odpowiedzialność Administratora.

2. Definicje

Użytkownik – osoba fizyczna, prawna lub jednostka organizacyjna posiadająca konto w Serwisie.
Obiekt – podmiot gospodarczy udostępniający swoje usługi (np. strzelnica, kort tenisowy, hala sportowa).
Trener – instruktor, osoba świadcząca usługi trenerskie, zarejestrowana na Platformie.
Rezerwacja – złożenie przez Użytkownika zamówienia na usługę sportową poprzez Serwis.
Regulamin obiektu – regulamin wewnętrzny obowiązujący w danym Obiekcie.

3. Zakres usług

3.1. Serwis umożliwia przeglądanie dostępnych obiektów i trenerów, dokonywanie rezerwacji oraz płatności online. Serwis umożliwia zakup produktów i usług obiektów, np. pakietów, karnetów, voucherów etc.

3.2. Administrator nie jest stroną umowy pomiędzy Użytkownikiem a Obiektem lub Trenerem – pełni funkcję pośrednika.

3.3. Użytkownik zobowiązany jest do zapoznania się z regulaminem danego Obiektu przed dokonaniem rezerwacji.

4. Rejestracja i konto użytkownika

4.1. W celu dokonania rezerwacji konieczne jest założenie konta w Serwisie.

4.2. Podczas rejestracji Użytkownik podaje dane osobowe: imię, nazwisko, adres e-mail, numer telefonu, a w przypadku działalności gospodarczej – również NIP.

4.3. Użytkownik jest zobowiązany do podania prawdziwych i aktualnych danych. Administrator nie ponosi odpowiedzialności za skutki wynikające z błędnych, niekompletnych lub nieaktualnych danych.

4.4. Użytkownik ponosi odpowiedzialność za zachowanie poufności loginu i hasła.

5. Zasady rezerwacji, zakupów, modyfikacji i anulowania

5.1. Dokonanie rezerwacji, zakupu produktu lub usług oznacza zawarcie umowy pomiędzy Użytkownikiem a danym Obiektem lub Trenerem.
5.2. Warunki rezerwacji (ceny, godziny, zasady anulacji) mogą różnić się w zależności od Obiektu.
5.3. Wszystkie rezerwacje dokonywane za pośrednictwem Platformy są płatne online w momencie ich składania. Płatność realizowana jest za pośrednictwem operatora płatności TPAY.

5.4. Użytkownik dokonując zakupu wyraża zgodę na wystawienie faktury w postaci elektronicznej zamiast paragonu. Faktura będzie przesłana na wskazany w profilu adres e-mail oraz będzie rejestrowana w systemie KSEF.

5.5. Brak możliwości odstąpienia od umowy
Zgodnie z Art. 38, punktem 12 Praw Konsumenta "Wyjątki od prawa do odstąpienia od umowy" dla umów zawartych poza lokalem przedsiębiorstwa (w tym online), nie ma możliwości odstąpienia od rezerwacji obiektów sportowych i usług powiązanych, z wyznaczonym terminem lub okresem świadczenia usługi.

5.6. Modyfikacja i anulowanie terminu rezerwacji
Wdrożony model rezerwacji, dopuszcza możliwość modyfikacji lub anulowania rezerwacji w terminie do 48 godzin przed planowanym zdarzeniami.
Modyfikacja rezerwacji jest możliwa poprzez kontakt telefoniczny z Partnerem Biznesowym (obiektem), w terminie nie krótszym niż 48 godzin przed zdarzeniem. Modyfikacja jest dokonywana przez Partnera Biznesowego a dokonana zmiana będzie automatycznie widoczna w rezerwacjach aplikacji SPOTTO. Modyfikacja jest wykonywana bez kosztowo.
Anulowanie jest możliwe do 48 godzin przed terminem rezerwacji. W przypadku skutecznego anulowania, rezerwujący otrzymuje zwrot w wysokości 90% wartości rezerwacji. Pozostałe 10% wartości stanowią koszty operacyjne, które nie podlegają zwrotowi. Zwrot środków jest dokonywany bezpośrednio przez Partnera Biznesowego w formie ustalonej pomiędzy klientem a Partnerem Biznesowym.
Anulowanie i modyfikacje w czasie krótszym niż 48 godzin do zaplanowanego wydarzenia są niemożliwe a koszty nie podlegają zwrotowi.
Koszty operacyjne nie podlegają zwrotowi w żadnym przypadku anulacji.

5.7. Niestawienie się
W przypadku niestawienia się na zarezerwowany termin bez wcześniejszej anulacji, Użytkownikowi nie przysługuje zwrot środków.

5.8. Użytkownik zobowiązany jest do wypełnienia wszystkich wymagań uprawniające do korzystania z danego Obiektu (np. aktywna licencja, pozwolenie na broń na strzelnicy).

5.9. W przypadku braku wymaganych uprawnień lub błędnie podanych danych, które uniemożliwiają skorzystanie z usługi, Użytkownikowi nie przysługuje zwrot kosztów.

6. Odpowiedzialność

6.1. Administrator nie odpowiada za jakość usług świadczonych przez Obiekty lub Trenerów.

6.2. Administrator nie ponosi odpowiedzialności za brak możliwości skorzystania z rezerwacji wynikający z błędnych danych, braku uprawnień, braku wymaganych przez obiekt dokumentów w dniu wydarzenia, niewiedzy lub nieprzestrzegania regulaminów obiektów.

6.3. Każdy Obiekt posiada własny regulamin, który może zawierać dodatkowe wymagania i ograniczenia. Niniejszy Regulamin ich nie zastępuje. Użytkownik zobowiązany jest zapoznać się z Regulaminem każdego Obiektu i przestrzegania obowiązujących zasad.

6.4. Administrator nie odpowiada za szkody wynikłe z działania siły wyższej, awarii technicznych, przerw w dostępie do Internetu lub błędów systemu płatności.

7. Płatności i zwroty

7.1. Płatności realizowane są za pośrednictwem zewnętrznego operatora płatności TPAY.

7.2. Zwroty środków, po potrąceniu kosztów operacyjnych, są możliwe na warunkach opisanych w punkcie 5 i są wykonywane bezpośrednio przez Obiekt, którego dotyczy rezerwacja.

7.3. Administrator nie ponosi odpowiedzialności za odmowę zwrotu w przypadku niespełnienia warunków opisanych w punkcie 5.

8. Reklamacje
8.1. Reklamacje dotyczące usług Obiektów należy kierować bezpośrednio do danego Obiektu.

8.2. Reklamacje dotyczące działania Platformy należy składać mailowo na adres: reklamacje@spotto.pl.

8.3. Reklamacje dotyczące Platformy są obsługiwane na bieżąco. Administrator zobowiązuje się do podjęcia działań w sprawie pojedynczego zgłoszenia nie później niż w terminie 14 dni od dnia jego otrzymania. Rozwiązanie sprawy nastąpi niezwłocznie, w czasie niezbędnym do prawidłowej obsługi danego zdarzenia, z uwzględnieniem jego charakteru, stopnia skomplikowania oraz konieczności współpracy z Obiektem lub Trenerem.

9. Postanowienia końcowe
9.1. Administrator zastrzega sobie prawo do zmiany Regulaminu. O każdej zmianie Użytkownik zostanie poinformowany z wyprzedzeniem.

9.2. W sprawach nieuregulowanych Regulaminem zastosowanie mają przepisy Kodeksu cywilnego i ustawy o świadczeniu usług drogą elektroniczną.

9.3. Regulamin wchodzi w życie z dniem 09.10.2025.
`,

  // Privacy policy (RODO)
  PRIVACY_POLICY: `POLITYKA PRZETWARZANIA DANYCH OSOBOWYCH (RODO)

1. Administrator danych

Administratorem danych osobowych jest SOLIDLABS PSA, ul. Mogilska 43, 31-545 Kraków, Polska, NIP: 6751768986, dalej zwany „Administratorem".

2. Zakres przetwarzanych danych

Administrator przetwarza następujące dane osobowe:
• imię i nazwisko,
• adres e-mail,
• numer telefonu,
• NIP (jeśli dotyczy),
• dane dotyczące dokonanych rezerwacji, płatności i historii korzystania z Platformy.

3. Cele i podstawa prawna przetwarzania

Dane osobowe przetwarzane są w celu:

1. umożliwienia rejestracji konta i korzystania z Platformy (art. 6 ust. 1 lit. b RODO),
2. realizacji rezerwacji usług sportowych (art. 6 ust. 1 lit. b RODO),
3. obsługi reklamacji i kontaktu z Użytkownikiem (art. 6 ust. 1 lit. c i f RODO),
4. marketingu bezpośredniego (na podstawie zgody, art. 6 ust. 1 lit. a RODO),
5. realizacji obowiązków księgowych i podatkowych (art. 6 ust. 1 lit. c RODO).

4. Przekazywanie danych

Dane mogą być przekazywane:
• Obiektom i Trenerom, u których dokonywana jest rezerwacja,
• operatorom płatności,
• dostawcom usług IT i hostingu,
• uprawnionym organom publicznym na podstawie przepisów prawa.

5. Okres przechowywania danych

Dane osobowe są przechowywane:
• przez okres niezbędny do realizacji rezerwacji i obsługi konta,
• przez okres wymagany przepisami prawa (np. podatkowego – 5 lat),
• dane przetwarzane na podstawie zgody – do momentu jej wycofania.

6. Prawa użytkownika

Użytkownik ma prawo do:
• dostępu do danych,
• sprostowania, usunięcia lub ograniczenia przetwarzania,
• przenoszenia danych,
• sprzeciwu wobec przetwarzania,
• cofnięcia zgody w dowolnym momencie.

Żądania można kierować na adres e-mail: rodo@spotto.pl.

7. Bezpieczeństwo danych

Administrator stosuje środki techniczne i organizacyjne zapewniające ochronę danych osobowych przed nieuprawnionym dostępem, utratą lub modyfikacją.

8. Inspektor Ochrony Danych

Jeśli Administrator powołał Inspektora Ochrony Danych, jego dane kontaktowe zostaną podane na stronie Serwisu.

9. Pliki cookies

Serwis wykorzystuje pliki cookies w celach statystycznych, funkcjonalnych i marketingowych. Użytkownik może w każdej chwili zmienić ustawienia przeglądarki w zakresie cookies.

10. Zmiany polityki prywatności

Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej polityce. Aktualna wersja dokumentu dostępna jest na stronie internetowej Serwisu.
`,

  // Terms specific to business/facility owners
  BUSINESS_TERMS: `REGULAMIN OBIEKTU PLATFORMY SPOTTO.PL
1. Postanowienia ogólne
1.1. Regulamin określa zasady współpracy Obiektu z platformą rezerwacyjną SPOTTO.pl, prowadzoną przez SOLIDLABS PSA („Administrator").
1.2. Obiektem jest podmiot prowadzący działalność sportową lub rekreacyjną, udostępniający swoje usługi Użytkownikom Platformy.
1.3. Korzystanie z Platformy oznacza akceptację niniejszego Regulaminu oraz Regulaminu Głównego SPOTTO.

2. Obowiązki formalne i uprawnienia Obiektu
2.1. Obiekt oświadcza, że posiada wszelkie wymagane przepisami prawa:
• zezwolenia, koncesje lub decyzje administracyjne,
• ubezpieczenie OC,
• spełnia wymogi sanitarne, techniczne i BHP.

2.2. Na żądanie Administratora Obiekt zobowiązany jest przedstawić dokumenty potwierdzające posiadanie wymaganych uprawnień.
2.3. Brak aktualnych uprawnień stanowi podstawę do natychmiastowego zawieszenia konta Obiektu.

3. Rezerwacje i płatności
3.1. Rezerwacje dokonywane przez Użytkowników są płatne i realizowane za pośrednictwem systemu transakcyjnego Platformy.
3.2. Obiekt zobowiązuje się do rzetelnego utrzymywania dostępności terminów i cen.
3.3. Każda rezerwacja stanowi wiążącą umowę pomiędzy Użytkownikiem a Obiektem – Administrator nie jest jej stroną.

4. Anulowanie rezerwacji i zwroty
4.1. Obiekt akceptuje możliwość anulowania rezerwacji przez Użytkownika nie później niż na 48 godzin przed planowanym rozpoczęciem wydarzenia.
4.2. W przypadku skutecznej anulacji Obiekt zobowiązany jest do zwrotu środków pomniejszonych o 10% wartości rezerwacji, stanowiących koszty operacyjne Platformy w terminie nie przekraczającym 14 dni roboczych.
4.3. Poprawnie zgłoszona anulacja jest potwierdzana automatycznie wiadomością e-mail.
4.4. Forma i termin zwrotu pozostałej kwoty ustalane są pomiędzy Obiektem a Użytkownikiem – Administrator nie pośredniczy w rozliczeniach.
4.5. W przypadku odwołania wydarzenia z winy Obiektu, Obiekt zobowiązany jest do pełnego zwrotu środków Użytkownikowi.

5. Odpowiedzialność Obiektu
5.1. Obiekt ponosi pełną odpowiedzialność za:
• bezpieczeństwo Użytkowników na terenie obiektu,
• stan techniczny infrastruktury,
• realizację usług zgodnie z opisem.

5.2. Administrator nie ponosi odpowiedzialności za niewykonanie lub nienależyte wykonanie usług przez Obiekt.
5.3. Wszelkie roszczenia Użytkowników dotyczące realizacji usług kierowane są bezpośrednio do Obiektu.

6. Reklamacje i zgłoszenia nieprawidłowości
6.1. Obiekt zobowiązuje się do rzetelnego i terminowego rozpatrywania reklamacji Użytkowników, rekomenduje się podjęcie tematu w terminie nie przekraczającym 14 dni od daty wpływu zgłoszenia.
6.2. Użytkownik ma prawo zgłosić Administratorowi przypadki nieuczciwych, nieprofesjonalnych lub niezgodnych z Regulaminem działań Obiektu.
6.3. Administrator nie jest stroną rezerwacji i nie ponosi odpowiedzialności za działania Obiektu.
6.4. W przypadkach rażących naruszeń Administrator może zawiesić konto Obiektu lub rozwiązać umowę ze skutkiem natychmiastowym.

7. Postanowienia końcowe
7.1. Administrator ma prawo monitorować jakość usług w celu ochrony reputacji Platformy.
7.2. Regulamin podlega prawu polskiemu.
7.3. Naruszenie Regulaminu stanowi podstawę do zakończenia współpracy.
`
};

// Document keys for API
export type LegalDocumentKey =
  | 'MAIN_TERMS'
  | 'PRIVACY_POLICY'
  | 'BUSINESS_TERMS';

// Export individual terms for easy access
export const MAIN_TERMS = TERMS_CONTENT.MAIN_TERMS;
export const PRIVACY_POLICY = TERMS_CONTENT.PRIVACY_POLICY;
export const BUSINESS_TERMS = TERMS_CONTENT.BUSINESS_TERMS;
